module.exports = __webpack_public_path__ + "static/media/security.d46a5447.svg";